var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "comment-list" },
    _vm._l(_vm.list, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "comment-list-item" },
        [
          _c(
            "div",
            { staticClass: "parent-reply reply" },
            [
              _c(
                "div",
                { staticClass: "user-info" },
                [
                  _c("xr-avatar", {
                    staticClass: "user-img",
                    attrs: {
                      name: item.userInfo.realname,
                      id: item.userInfo.user_id || item.userInfo.id,
                      size: 34,
                      src: item.userInfo.thumb_img || item.userInfo.img,
                      disabled: false,
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-info__bd" }, [
                    _c("div", { staticClass: "user" }, [
                      _vm._v(_vm._s(item.userInfo.realname)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "time" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.create_time) +
                          "\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "span",
                      {
                        staticClass: "reply-btn",
                        on: {
                          click: function ($event) {
                            return _vm.handleToReply(index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "wk wk-reply" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("回复")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "delete-btn",
                        on: {
                          click: function ($event) {
                            return _vm.handleToDelete(item, index)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "wk wk-s-delete" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("删除")]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "content",
                domProps: { innerHTML: _vm._s(_vm.emoji(item.content)) },
              }),
              _vm._v(" "),
              _vm.replyIndex === String(index)
                ? _c("reply-comment", {
                    on: {
                      reply: _vm.handleReply,
                      close: function ($event) {
                        _vm.replyIndex = null
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          item.childCommentList && item.childCommentList.length > 0
            ? _vm._l(item.childCommentList, function (child, childIndex) {
                return _c("div", { key: childIndex }, [
                  _c(
                    "div",
                    { staticClass: "child-reply reply" },
                    [
                      _c(
                        "div",
                        { staticClass: "user-info" },
                        [
                          _c("xr-avatar", {
                            staticClass: "user-img",
                            attrs: {
                              name: child.userInfo.realname,
                              id: child.userInfo.user_id,
                              size: 34,
                              src: child.userInfo.img,
                              disabled: false,
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "user-info__bd" }, [
                            _c("div", { staticClass: "user" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(child.userInfo.realname) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(child.create_time) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "control" }, [
                            _c(
                              "span",
                              {
                                staticClass: "reply-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleToReply(index, childIndex)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "wk wk-reply" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("回复")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "delete-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleToDelete(
                                      child,
                                      index,
                                      childIndex
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "wk wk-s-delete" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("删除")]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "child-content" }, [
                        _c("span", [
                          _vm._v(
                            "\n              回复 @" +
                              _vm._s(child.replyuserInfo.realname) +
                              "：\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "content",
                          domProps: {
                            innerHTML: _vm._s(_vm.emoji(child.content)),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.replyIndex === `${index}-${childIndex}`
                        ? _c("reply-comment", {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.commentLoading,
                                expression: "commentLoading",
                              },
                            ],
                            on: {
                              reply: _vm.handleReply,
                              close: function ($event) {
                                _vm.replyIndex = null
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              })
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }